import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import {BrowserRouter} from "react-router-dom";
import "assets/css/index.css"
import {AppDataProvider} from "@/mobx/appDataStore.jsx";

ReactDOM.createRoot(document.getElementById('root')).render(
  <AppDataProvider>
    <BrowserRouter>
      <App/>
    </BrowserRouter>
  </AppDataProvider>
)
